export const defaultProgramDetails = {
  sections: [
    {
      title: 'THÔNG TIN CHI TIẾT CHƯƠNG TRÌNH:',
      items: [],
    },
    {
      title: 'LƯU Ý QUAN TRỌNG DÀNH CHO HỌC SINH:',
      items: [],
    },
  ],
  form_note:
    'Học sinh vui lòng điền đầy đủ và chính xác các thông tin theo biểu mẫu dưới đây để hoàn tất đăng ký:',
};

export const defaultExamDateOptions = [
  { value: '2026-10-03', label: 'Thứ Bảy ngày 03/10/2026' },
];

export const defaultFormConfig = {
  messages: {
    closed: 'Đợt đăng ký đã đóng',
    closed_suffix: '(hạn cuối {deadline})',
    success_title: 'Đăng ký thành công',
    success_subtitle:
      'Thông tin chi tiết về ca thi sẽ được gửi qua email của học sinh trước ngày thi.',
    submit_button: 'Gửi đăng ký',
    register_success: 'Đăng ký thi trải nghiệm TSA thành công',
    duplicate_citizen_id: 'Số CCCD này đã được đăng ký cho đợt thi trải nghiệm',
    period_closed: 'Đợt đăng ký đã đóng hoặc đã hết chỗ',
  },
  fields: [
    {
      name: 'account_email',
      type: 'email',
      label: 'Email',
      placeholder: 'Email tài khoản',
      required: true,
      readonly_when_logged_in: true,
    },
    {
      name: 'full_name',
      type: 'text',
      label: 'Họ và tên',
      placeholder: 'Họ và tên đầy đủ',
      required: true,
    },
    {
      name: 'birth_date',
      type: 'date',
      label: 'Ngày/tháng/năm sinh',
      placeholder: 'Chọn ngày sinh',
      required: true,
    },
    {
      name: 'grade',
      type: 'radio',
      label: 'Học sinh Lớp',
      required: true,
      options: [
        { value: '11', label: 'Lớp 11' },
        { value: '12', label: 'Lớp 12' },
      ],
    },
    {
      name: 'school',
      type: 'school',
      label: 'Học sinh Trường',
      required: true,
      labels: {
        province: 'Tỉnh/TP',
        ward: 'Phường/Xã',
        school: 'Trường THPT',
      },
      placeholders: { school: 'Tên trường THPT' },
    },
    {
      name: 'citizen_id',
      type: 'citizen_id',
      label: 'Số Căn cước công dân (dùng để tạo tài khoản dự thi)',
      placeholder: 'Số CCCD',
      required: true,
      max_length: 12,
      pattern: '^\\d{9,12}$',
      pattern_message: 'Số CCCD phải gồm 9–12 chữ số',
    },
    {
      name: 'student_email',
      type: 'email',
      label: 'Email của học sinh (dùng để nhận thông tin dự thi)',
      placeholder: 'Email học sinh',
      required: true,
    },
    {
      name: 'exam_date',
      type: 'exam_date',
      label: 'Đăng ký Dự thi trải nghiệm TSA ngày',
      required: true,
    },
    {
      name: 'favorite_major',
      type: 'text',
      label: 'Ngành học/Lĩnh vực yêu thích',
      placeholder: 'Ngành học hoặc lĩnh vực yêu thích',
      required: true,
    },
    {
      name: 'phone',
      type: 'phone',
      label: 'Số điện thoại',
      placeholder: 'Số điện thoại',
      required: true,
      pattern: '^(0|\\+84)\\d{9,10}$',
      pattern_message: 'Số điện thoại không hợp lệ',
    },
  ],
};
